import React from 'react'
import {Link} from 'react-router-dom'

import BiddingContractSubstep from './BiddingContractSubstep'
import TeamMemberPanel from '../teams/MemberPanel'

export default class BiddingContractTeamMembersSubstep extends BiddingContractSubstep
{
	static SubstepName = 'start_project.contract_team_members.title';

	static TranslationKey = 'start_project.contract_team_members';

	static SubstepSlug = 'team-members';
    static path = '/team-members';

	renderServiceTeam(project)
	{
		if (!project.selectedTeam()) {
			return <div/>
		}

		let team = project.selectedTeam(),
			vips = team.vipsForProject(project),
			otherPositions = team.nonVipsForProject(project);

		return (
			<div>
				<div className="flex justify-between">
					<p style={styles.groupTitle}>{team.name}</p>
					<Link to={`/team-profiles/${team.id}?projectId=${project.id}`}
						style={styles.profileLink}>
						{this.trans('profile_link')}
					</Link>
				</div>

				{vips.length > 0 && (
					<div className='row mb-5'>
						{vips.map((vip,i) => (
							<div key={`teamVIP${i}`}
								className="md:w-4/12 mb-4"
								style={styles.memberPanelContainer}>
								<TeamMemberPanel
									member={vip}
									team={team}
									project={project}/>
							</div>
						))}
					</div>
				)}

				{otherPositions.length > 0 && (
					<p style={styles.groupTitle}>
						{this.trans('more_members_label')}
					</p>
				)}
				<div className='row'>
					{otherPositions.map((position,i) => (
						<div key={`teamPosition${i}`}
							className="md:w-4/12 mb-4"
							style={styles.memberPanelContainer}>
							<TeamMemberPanel
								member={position}
								team={team}
								project={project}/>
						</div>
					))}
				</div>
			</div>
    	);
	}

	renderPositions(project)
	{
		let positions = project.sortedPositions();

		return (
			<div>
				<div className='row'>
					{positions.map((position,i) => (
						<div key={`teamPosition${i}`}
							className="md:w-4/12 mb-4"
							style={styles.memberPanelContainer}>
							<TeamMemberPanel
								member={position.assigned_candidate}
								position={position}
								project={project}/>
						</div>
					))}
				</div>
			</div>
    	);
	}

	render()
	{
		let {project} = this.props;
		if (!project) {
			return <div/>
		}

		if (project.isService()) {
			return this.renderServiceTeam(project);
		}

		if (project.isBYO()) {
			return this.renderPositions(project);
		}

		return <div/>;
	}
}

const styles = {
	groupTitle: {
		fontWeight: 500,
		textAlign: 'left',
		fontSize: 18,
		marginBottom: 25,
	},
	profileLink: {
		color: '#109CF1',
		borderBottom: '1px solid #109CF1',
	    height: '19px',
    	marginTop: '5px',
	},
	memberPanelContainer: {
		minWidth: '300px',
	},
};